import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { viewMenu, hideMenu, deconnectUser, connectUser } from '../actions/actions-types';
import { cle_COURTJUS, URL_COURTJUS_BACK } from '../constants/sources';
import { BIASSE_INIT } from '../constants/globals';
import { useAppContext } from '../AppContext'; // Importer le contexte

const Header = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { userMenu, userCJ } = useSelector(state => state);
    const { state } = useAppContext(); // Utiliser le contexte pour accéder à l'état partagé
    const [user, setUser] = useState({ email: "", mdp: "", msg: "" });
    const [biasse, setBiasse] = useState([]);
    const [nbCde, setNbCde] = useState(0);
    const headers = new Headers();
    const [showAide, setShowAide] = useState(false);
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        fetch(`${URL_COURTJUS_BACK}/biasseactive`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res === null) {
                    const newBiasse = BIASSE_INIT;
                    newBiasse.cmdOpen = false;
                    setBiasse(newBiasse);
                } else {
                    const dateNow = new Date();
                    const dateB = new Date(res.bDate.substring(0, 10));
                    const dateBCI = new Date(res.bDateCdeIni.substring(0, 10));
                    const dateBCE = new Date(res.bDateCdeEnd.substring(0, 10));
                    const dateBCE1 = new Date(res.bDateCdeEnd.substring(0, 10));
                    dateBCE1.setDate(dateBCE.getDate() + 1);
                    if (dateBCI <= dateNow && dateBCE1 >= dateNow) { res.cmdOpen = true } else { res.cmdOpen = false };
                    res.bDate = dateB.toLocaleDateString();
                    res.bDateCdeIni = dateBCI.toLocaleDateString();
                    res.bDateCdeEnd = dateBCE.toLocaleDateString();
                    setBiasse(res);
                }
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const clickOn = (event) => {
        dispatch(viewMenu());
    };

    const clickOff = (event) => {
        dispatch(hideMenu());
    };

    // Fonction pour fermer le menu
    const clickOffOnLoad = () => {
        dispatch(hideMenu());
        const navbarToggler = document.querySelector('.navbar-toggler');
        const navbarCollapse = document.querySelector('#navbarResponsive');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            navbarToggler.click(); // Ferme le menu
        }
    };

    useEffect(() => {
        clickOffOnLoad();
    }, [location.pathname]); // Déclenché quand l'URL change

    const deconnect = (event) => {
        dispatch(deconnectUser());
        dispatch(hideMenu());
    };

    const userNum = userCJ.uNum;
    let userActif = false;

    if (userCJ.uActif !== 0) {
        const now = new Date();
        const sixHoursAgo = new Date(now.getTime() - 3 * 60 * 60 * 1000);
        const derConnect = new Date(userCJ.uDateLastConnect);
        if (derConnect < sixHoursAgo) {
            deconnect()
        }
    }

    if (userCJ.uActif !== 0) { userActif = true }
    let userAdherent = false;
    if (userCJ.uAdherent !== 0) { userAdherent = true }
    let userProducteur = false;
    if (userCJ.uProducteur !== 0) { userProducteur = true }
    let userCommission = false;
    if (userCJ.uCommission !== 0) { userCommission = true }
    let userAdmin = false;
    if (userCJ.uAdmin !== 0) { userAdmin = true }
    let secuCommandes = false;
    if (userProducteur || userCommission || userAdmin) { secuCommandes = true };
    let secuArticles = false;
    if (userProducteur || userAdmin) { secuArticles = true };

    const ViewPanier = `0_0_0_${userNum}_0___`; // biasse active _ par adherents _ en mode liste _ utilisateur seul _ tous les producteurs _ pas de filtre text
    let ViewCmd = `0_0_0`; // biasse active _ par adherents _ en mode liste
    if (!userAdmin && !userCommission && !userProducteur) { ViewCmd += `_${userNum}` } else { ViewCmd += `_0` }; // ne voir que son propre panier si uniquement adherent
    if (!userAdmin && !userCommission && userProducteur) { ViewCmd += `_${userNum}` } else { ViewCmd += `_0` }; // ne voir que les commandes qui lui sont destinées si uniquement producteur
    ViewCmd += `___`; // pas de filtre text par defaut : _adherents _ producteurs _ articles

    const handleSubmit = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        setUser(oldUser => { return { ...user, [name]: value, }; });

        fetch(URL_COURTJUS_BACK + '/userconnect', {
            method: 'POST',
            body: JSON.stringify(user),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'cle': cle_COURTJUS,
            },

        })
            .then(res => res.json())
            .then(data => {
                if (data === null) {
                    setUser(oldUser => { return { ...user, msg: "Mot de passe ou adresse mail incorrect ! " }; });
                } else {
                    setUser(oldUser => { return { ...user, msg: "" + data[0].uPrenom, }; });
                    dispatch(connectUser({ data }))
                }
            })
            .catch(err => console.error(err));
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUser(oldUser => { return { ...user, [name]: value, }; });
        event.preventDefault();
    };

    return (
        <div className='no-print'>
            <nav className="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
                <div className="container">
                    {(userMenu !== true || userNum !== 0) &&
                        <a className="btn btn-primary text-uppercase zone-trans-masque" href="https://court-jus.fr/" target='blank'><img width="100rem" src="/assets/img/court_jus_transparent.png" alt="..." /></a>
                    }
                    <button className="navbar-toggler" style={{ backgroundColor: '#7f0103' }} type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        Menu
                        <i className="fas fa-bars ms-1"></i>
                    </button>
                    {(userMenu === true && userNum === 0) &&
                        <section className="nav-admin fond-plus">
                            {userNum === 0 &&
                                <form method="POST" id="formConnect" onSubmit={handleSubmit}>
                                    <label htmlFor="email">Mail</label>&nbsp;
                                    <input type="email" name="email" id="email" value={user.email} onChange={handleChange} required tabIndex="1" />
                                    <NavLink to={`/userfichecreat`} className="btn-admin" title="Créer mon compte" tabIndex="4">
                                        <img src="/img/user_add.png" className="btn-articles" alt="Créer mon compte" />
                                    </NavLink><br />
                                    <label htmlFor="mdp">MdP</label>&nbsp;
                                    <input type="password" id="mdp" name="mdp" value={user.mdp} onChange={handleChange} required tabIndex="2" />
                                    <NavLink to={`/userfichereinit`} className="btn-admin" title="J'ai perdu mon mot de passe" tabIndex="5">
                                        <img src="/img/manage_reinit.png" className="btn-articles" alt="J'ai perdu mon mot de passe" />
                                    </NavLink><br /><br />
                                    <button className="btn btn-primary text-uppercase" tabIndex="3">Se connecter</button>
                                </form>
                            }
                        </section>
                    }
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav text-uppercase ms-auto py-4 py-lg-0 fond-plus">
                            {(userMenu && userNum === 0) && <li className="nav-item"><NavLink data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" className="btn-admin" aria-label="admin" onClick={clickOff} title="admin"><img src="/img/manage_no.png" alt="masquer le menu utilisateur" /></NavLink></li>}
                            <li className="nav-item"><NavLink className="nav-link text-plus" to="./travel/1" aria-label="Qui sommes nous" title="Qui sommes nous">Nous</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link text-plus" to="./producteurs" aria-label="Nos Producteurs" title="Nos Producteurs">Producteurs</NavLink></li>
                            {(userNum == 0 || !biasse.cmdOpen) && <li className="nav-item"><NavLink className="nav-link text-plus" to="./articles" aria-label="leurs Produits" title="leurs Produits">Produits</NavLink></li>}
                            {(userNum !== 0 && biasse.cmdOpen) && <li className="nav-item"><NavLink className="nav-link text-plus" to="/jecommande" aria-label="Pré-Commander" title="Commander">Commander</NavLink></li>}
                            {userNum !== 0 && <li className="nav-item"><NavLink className="nav-link text-plus" to={`/mescommandes/${ViewPanier}`} aria-label="Voir mon Panier" title="Voir ma Commande"><span className='zone-trans-masque'>Mon </span>panier</NavLink></li>}
                            <li className="nav-item"><NavLink className="nav-link text-plus" to="./biasses" aria-label="Les Biasses - Les Marchés" title="Les Biasses - Les Marchés">Biasses</NavLink></li>
                            {userNum !== 0 &&
                                <>
                                    {userProducteur && <li className="nav-item"><NavLink className="nav-link text-plus" to={`/articles/${userNum}`} aria-label="Gérer les Articles à la vente" title="Gérer les Articles à la vente">Gerer</NavLink></li>}
                                    {userProducteur && <li className="nav-item"><NavLink className="nav-link text-plus" to={`/lescommandesPro/${ViewCmd}`} aria-label="Voir les Commandes qui m'ont été faites" title="Voir les Commandes qui m'ont été faites">Commandes</NavLink></li>}
                                    {userAdmin && <li className="nav-item"><NavLink className="nav-link text-plus" to={`/lescommandes/${ViewCmd}`} aria-label="Voir toutes les Commandes de tout le monde" title="Voir toutes les Commandes de tout le monde">Commandes</NavLink></li>}
                                    {userAdmin && <li className="nav-item"><NavLink className="nav-link text-plus" to="/adherents" aria-label="Gérer les Membres" title="Gérer les Membres">Membres</NavLink></li>}
                                </>
                            }
                            <li className="nav-item">
                                {userNum == 0 && <NavLink data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" className="btn-admin" aria-label="Me connecter" onClick={clickOn} title="Me connecter"><img src="/img/connexion.png" className="btn-articles" alt="Me connecter" style={{ marginTop: "6px", width: "100px" }} /></NavLink>}
                                {userNum !== 0 && <><NavLink to="/userficheup" className={'btn-admin'} aria-label="Modifier ma Fiche" title="Modifier ma Fiche"><img src="/img/manage_user.png" alt="Modifier ma Fiche" style={{ marginTop: "4px" }} /></NavLink>
                                    <NavLink className="btn-admin" to="#" aria-label="Me deconnecter" onClick={deconnect} title="Me deconnecter"><img src="/img/user_off.png" alt="Me deconnecter" className="btn-articles" style={{ marginTop: "4px" }} /></NavLink></>}
                            </li>
                            <li className="nav-item"
                                style={{ position: 'relative', display: 'inline-block' }}
                                onMouseEnter={() => setShowAide(true)}
                                onMouseLeave={() => setShowAide(false)}>

                                {/* L'icône point d'interrogation qui sert de déclencheur */}
                                <span className="btn-admin zone-trans-masque" style={{ cursor: 'pointer' }}>
                                    <img width={'1rem'} src="/img/aide.png" alt="Aide utilisateur" />
                                </span>

                                {/* Le menu qui apparaît au survol */}
                                {showAide && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        right: 0,
                                        backgroundColor: '#000000ad', // Couleur assortie à votre menu
                                        padding: '4px',
                                        borderRadius: '5px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        textAlign: 'right',
                                        gap: '4px',
                                        zIndex: 1000,
                                        minWidth: '140px',
                                        boxShadow: '0px 4px 8px rgba(0,0,0,0.3)'
                                    }}>
                                        <a className="nav-link text-plus" style={{ fontSize: '0.8rem', textTransform: 'none' }}
                                            href="https://biasses.court-jus.fr/Guide_adherents.pdf" target='_blank' rel="noreferrer" title='Guide Adhérents'>
                                            Adhérents
                                        </a>
                                        {(userNum !== 0 && userProducteur) && <a className="nav-link text-plus" style={{ fontSize: '0.8rem', textTransform: 'none' }}
                                            href="https://biasses.court-jus.fr/Guide_producteurs.pdf" target='_blank' rel="noreferrer" title='Guide Producteurs'>
                                            Producteurs
                                        </a>}
                                        {(userNum !== 0 && userAdmin) && <a className="nav-link text-plus" style={{ fontSize: '0.8rem', textTransform: 'none' }}
                                            href="https://biasses.court-jus.fr/Guide_producteurs.pdf" target='_blank' rel="noreferrer" title='Guide Producteurs'>
                                            Producteurs
                                        </a>}
                                        {(userNum !== 0 && userAdmin) && <a className="nav-link text-plus" style={{ fontSize: '0.8rem', textTransform: 'none' }}
                                            href="https://biasses.court-jus.fr/Guide_administrateurs.pdf" target='_blank' rel="noreferrer" title='Guide Administrateurs'>
                                            Admin
                                        </a>}
                                    </div>
                                )}
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
            <header className="masthead">
                <div className="container">
                    <div className="masthead-subheading text-plus">Association de consom'acteurs tournée vers les circuits courts alimentaires.</div>
                    {user.msg && <div> {user.msg} </div>}
                    {/* <a className="btn btn-primary text-uppercase" href="mailto:court.jus.asso@gmail.com"><img width="150rem" src="assets/img/court_jus_transparent.png" alt="..." /></a> */}
                    {typeof biasse.bLibelle === 'string' && biasse.bLibelle.length > 0 && (
                        <div className='small-title'><br />
                            {state.headerValue && <span>{state.headerValue}</span>}
                            {!state.headerValue && (
                                <>{biasse.bLibelle} : le {biasse.bDate}
                                    {/* {biasse.cmdOpen}<br /> <span className="p-impact">{!biasse.cmdOpen && ` ( Commandes fermées ) `}</span>
                                {biasse.cmdOpen && <span className="p-impact fond-plus-soustitre">{`commandes entre le ${biasse.bDateCdeIni} et le ${biasse.bDateCdeEnd}`}</span>}  */}
                                    <br /><span className="p-impact fond-plus-soustitre">{`commandes entre le ${biasse.bDateCdeIni} et le ${biasse.bDateCdeEnd}`}</span>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </header>
        </div>
    )
}

export default Header;
